import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../Components/Sidebar";
import { LuUserCheck } from "react-icons/lu";
import { TbLayout2, TbUsers } from "react-icons/tb";
import DepartmentList from "./DepartmentList";
import { addDepartment } from "../../redux/actions/departmentActions";
import PageComponent from "../../Components/PageComponent";

function DepartmentManagement() {
  const [departmentName, setDepartmentName] = useState("");
  const [description, setDescription] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate inputs
    if (!departmentName.trim() || !description.trim()) {
      alert("Please fill in all fields.");
      return;
    }

    // Dispatch addDepartment action
    const departmentInfo = { department_name: departmentName, description };
    dispatch(addDepartment(departmentInfo))
      .then(() => {
        alert("Department added successfully!");
        window.location.reload();
        setDepartmentName("");
        setDescription("");
      })
      .catch((error) => {
        console.error("Error adding department:", error);
        alert("Failed to add department.");
      });
  };

  return (
    <><PageComponent>
    <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
      <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
        <Sidebar />
      </div>
      <div className="flex-1 p-6 ml-64">
        <div className="flex items-center space-x-2 text-3xl text-gray-500">
          <span>Academics & International</span>
          <span>/</span>
          <span className="text-black">Department Management</span>
        </div>
        <div className="flex items-center mt-4 space-x-4">
          <button
            className="flex items-center px-4 py-2 text-white bg-[#92288C] rounded-lg shadow hover:bg-[#6C0B67]"
            onClick={() =>
              navigate("/academics&international/departmentManagement/leadershipMessages")
            }
          >
            <TbLayout2 className="mr-2" />
            Department
          </button>
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() =>
              navigate("/academics&international/departmentManagement/leadershipMessages")
            }
          >
            <LuUserCheck className="mr-2" />
            Leadership Messages
          </button>
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() =>
              navigate("/academics&international/departmentManagement/academicStaff")
            }
          >
            <TbUsers className="mr-2" />
            Academic Staff
          </button>
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() =>
              navigate("/academics&international/departmentManagement/allStaff")
            }
          >
            <TbUsers className="mr-2" />
            All Staff
          </button>
        </div>

        <div className="p-6 mt-6 bg-white rounded-lg shadow-md">
          <form onSubmit={handleSubmit}>
            <h2 className="mb-4 text-xl font-semibold text-gray-700">
              Add New Department
            </h2>
            <div className="space-y-4">
              <div>
                <label className="block text-gray-700">Department Name</label>
                <input
                  id="name"
                  type="text"
                  value={departmentName}
                  onChange={(e) => setDepartmentName(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                />
              </div>
              <div>
                <label className="block text-gray-700">Description</label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                />
              </div>
            </div>
            <div className="flex justify-end mt-6 space-x-4">
              <button
                type="reset"
                onClick={() => {
                  setDepartmentName("");
                  setDescription("");
                }}
                className="px-4 py-2 text-[#A8AAAE] bg-gray-200 rounded-md hover:bg-gray-300"
              >
                Clear
              </button>
              <button
                type="submit"
                className="px-4 py-2 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67]"
              >
                Save
              </button>
            </div>
          </form>
        </div>

        <div className="mt-6">
          <DepartmentList title="Department List" />
        </div>
      </div>
    </div>
    </PageComponent></>
  );
}

export default DepartmentManagement;
